/**
 * Perfil del trabajador (006 · T049; contracts/staff-api.md §2).
 *
 * `GET /profile` es **autenticada** (cookie `fermin_staff_session` + `X-Fermin-Device` firmada) y se
 * valida con `StaffProfileSchema` de `@fermin/contracts`; aquí no se redefine nada. Es de solo
 * lectura y cambia muy poco: `staleTime` global (10 s), sin `refetchOnWindowFocus`. Nada se
 * persiste (wiring 006 §0.7): vive solo en la caché en memoria de TanStack Query.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { StaffProfileSchema, type StaffProfile } from '@fermin/contracts';

import { api, type ApiError } from '../../api/client';

export const STAFF_PROFILE_QUERY_KEY = ['staff-profile'] as const;

export function fetchStaffProfile(signal?: AbortSignal): Promise<StaffProfile> {
  return api.get('/profile', { schema: StaffProfileSchema, ...(signal ? { signal } : {}) });
}

/** `GET /profile`. Con la empresa `SUSPENDED` responde `200` (lectura exenta, research R-12). */
export function useStaffProfile(): UseQueryResult<StaffProfile, ApiError> {
  return useQuery<StaffProfile, ApiError>({
    queryKey: STAFF_PROFILE_QUERY_KEY,
    queryFn: ({ signal }) => fetchStaffProfile(signal),
  });
}
